import {
  MODULE_SUCCESSFULLY_LOADED,
  UPDATE_UI,
  MODULE_LOAD_FAILED,
  MODULE_SESSION_EXPIRED,
  TOGGLE_COURSE_DETAILS,
  LOAD_CONTEXT,
  RELOAD_CONTEXT,
  PROCESS_RELOAD_CONTEXT,
  RECONNECT_ACTIVATE,
  RECONNECT_DEACTIVATE,
  RECONNECT_TRY,
  RECONNECT_WAIT,
  CONNECTION_OFFLINE,
  CONNECTION_ONLINE,
  REMOVE_AUDIO_MODAL,
  JUMP,
  UPDATE_FULL_SCREEN_FRAME
} from '../constants';
import config from '../config.json';
const initialState = {
  loadingCourse: true,
  loaded: '',
  moduleData: {
    'main-title': '',
    'sub-title': '',
    'lesson-nav-prev': { enabled: false },
    'lesson-nav-next': { enabled: false },
    'history-pagination': false
  },
  showCourseDetails: false,
  inChatRoom: false,
  reconnect: { active: false, state: '', retryInSeconds: config.automaticReconnectTimeout / 1000 },
  pageNumber: 0,
  fullScreenFrameUrl: null
};

export default function (state = initialState, action) {
  switch (action.type) {
    case MODULE_SESSION_EXPIRED:
      return { ...state, loaded: 'expired', loadingCourse: false };
    case MODULE_LOAD_FAILED:
      return { ...state, loaded: 'failed', loadingCourse: false };
    case UPDATE_UI:
      let newData = { ...state.moduleData };
      newData[action.payload.element] = action.payload.value;
      return { ...state, moduleData: newData };
    case MODULE_SUCCESSFULLY_LOADED:
      return { ...state, loadingCourse: false, loaded: 'success' };
    case TOGGLE_COURSE_DETAILS:
      return {
        ...state,
        showCourseDetails: action.payload !== undefined ? action.payload : !state.showCourseDetails
      };
    case PROCESS_RELOAD_CONTEXT:
      return initialState;
    case RELOAD_CONTEXT:
      return { ...state, pageNumber: 0, inChatRoom: true };
    case LOAD_CONTEXT:
      return { ...state, pageNumber: state.pageNumber + 1, inChatRoom: true };
    case JUMP:
      return { ...state, inChatRoom: true };
    // a request failing while the device is offline doesn't change what the learner is waiting for:
    // the saga waits for the connection, so a countdown here would tick towards nothing
    case RECONNECT_ACTIVATE:
      return {
        ...state,
        reconnect: {
          ...state.reconnect,
          active: true,
          state: state.reconnect.state === 'offline' ? 'offline' : 'waiting'
        }
      };
    // no point counting down to an attempt that can't reach anything while the device is offline
    case CONNECTION_OFFLINE:
      return { ...state, reconnect: { ...state.reconnect, active: true, state: 'offline' } };
    // the saga can't see this arrive while a request is in flight, so the banner stops saying the
    // device has no connection as soon as it does
    case CONNECTION_ONLINE:
      return state.reconnect.state === 'offline'
        ? { ...state, reconnect: { ...state.reconnect, state: 'reconnecting' } }
        : state;
    // a failed attempt returns to the countdown, with the delay the saga will actually wait
    case RECONNECT_WAIT:
      return {
        ...state,
        reconnect: {
          active: true,
          state: 'waiting',
          retryInSeconds: action.payload.retryInSeconds
        }
      };
    case RECONNECT_DEACTIVATE:
      return { ...state, reconnect: initialState.reconnect };
    case RECONNECT_TRY:
      return { ...state, reconnect: { ...state.reconnect, active: true, state: 'reconnecting' } };
    case REMOVE_AUDIO_MODAL:
      return { ...state, playModal: false };
    case UPDATE_FULL_SCREEN_FRAME:
      return { ...state, fullScreenFrameUrl: action.payload };
    default:
      return state;
  }
}
